import { Container, Heading, Text } from "@chakra-ui/react";

import DeleteConfirmation from "./DeleteConfirmation";

const DeleteAccount = () => {
  return (
    <Container maxW="full">
      <Heading size="sm" py={4}>
        계정 삭제
      </Heading>
      <Text>데이터와 계정 관련 모든 정보를 영구적으로 삭제합니다.</Text>
      <DeleteConfirmation />
    </Container>
  );
};
export default DeleteAccount;
